import { useContext } from "react";
import { ActiveCartItemContext } from "./context";

export const useActiveCartItem = () => {
  const context = useContext(ActiveCartItemContext);
  if (!context) {
    throw new Error("No ActiveCartItemContext context was provided. ");
  }
  return context;
};
